import React from 'react'

import './App.css';

import { Router } from 'react-router-dom'
import history from './Managers/history'
import {routes} from './Components/ComponentBuilder'

const App = () => {
  return (
    <div className="App">
      <Router history={history}>
        { routes }
      </Router>
    </div>
  )
}

export default App
